import {
  Environment,
  Network,
  RecordSource,
  Store,
  FetchFunction,
} from "relay-runtime";

const HTTP_ENDPOINT = `${process.env.LOCAL_URI || ""}/graphql/`;

const fetchFn: FetchFunction = async (request, variables) => {
  async function fetchQuery() {
    const resp = await fetch(HTTP_ENDPOINT, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        query: request.text, // <-- The GraphQL document composed by Relay
        variables,
      }),
    });
    return await resp.json();
  }
  const respJson = await fetchQuery();
  return respJson;
};

const source = new RecordSource();
const store = new Store(source);

const RelayEnvironment = new Environment({
  network: Network.create(fetchFn),
  store,
});
export default RelayEnvironment;
